import { render, staticRenderFns } from "./next-collection-single-garbage.vue?vue&type=template&id=5cace5db&scoped=true&"
import script from "./next-collection-single-garbage.vue?vue&type=script&lang=js&"
export * from "./next-collection-single-garbage.vue?vue&type=script&lang=js&"
import style0 from "./next-collection-single-garbage.vue?vue&type=style&index=0&id=5cace5db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cace5db",
  null
  
)

export default component.exports